import { actions as snactions } from '../../snackbar'
import service from '../parent-api-service'
import types from '../types'
import fetchParents from './fetch'
import inviteParent from './invite'

const updateParent = (parentId, original, updated) => (dispatch) => {
  dispatch({
    type: types.UPDATE_PARENTS_START,
  })
  return service
    .updateParent(parentId, original, updated)
    .then(() => {
      const emailWasUpdated = original.Email !== updated.Email
      dispatch({ type: types.UPDATE_PARENTS_SUCCESS })
      if (emailWasUpdated) {
        dispatch(inviteParent(parentId))
      } else {
        dispatch(fetchParents())
      }
    })
    .catch(() => {
      dispatch({ type: types.UPDATE_PARENTS_FAILURE })
      dispatch(snactions.addSnackbarItem('An error occured when updating a parent'))
    })
}

export default updateParent
